"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    items: [1, 2],
    itemsById: {
      1: {
        id: 1,
        title: 'Custom Tab 1',
        content: 'Tab 1 content etc...',
        collapsed: false
      },
      2: {
        id: 2,
        title: 'Custom Tab 2',
        content: 'Tab 2 content etc...',
        collapsed: true
      }
    },
    itemNextId: 3
  };
}